import { render } from "./IconChevronRight.vue?vue&type=template&id=2dcf8aa2"
const script = {}

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__